<div *ngIf="data">
    <h2>{{title | translate}}</h2>
    <div class="backside-material-info">
        <div class="d-flex">
            <div class="label">{{"newOrder.trialLens.backside" | translate}}:</div>
            <div class="value">{{lensBackSide}}</div>
        </div>
        <div class="d-flex">
            <div class="label">{{"newOrder.trialLens.material" | translate}}:</div>
            <div class="value">{{data.Material}}</div>
        </div>
    </div>

    <form class="d-flex flex-wrap form" [formGroup]="form" style="margin-top: 20px;">
        <div *ngFor="let feature of features; let i = index" class="feature-input">
            <label [matTooltip]="getHintTranslation(feature) | async" matTooltipPosition="above">{{getTranslation(feature) | async}}</label>
            <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                    <input type="text" class="form-control" [name]="feature.name" [formControlName]="feature.name" (blur)="setValueWithFormat(feature.name)" style="margin-right: 20px;">
                </div>
            </div>
        </div>
    </form>
    <h2  style="margin-top: 20px;">{{"newOrder.hechtProposal.response.additionalOptions" | translate}}</h2>
    <mat-radio-group [(ngModel)]="selectedAdditionalOption" (change)="calculateChildren($event)">
        <mat-radio-button class="additional-option-radio-button" *ngFor="let additionalOption of additionalOptions" [value]="additionalOption" style="margin-right: 20px;">
            <div class="d-flex">
                <div *ngIf="getKey(additionalOption) !== 'None'" style="display: inline">{{getKey(additionalOption)}}</div>
                <div *ngIf="getKey(additionalOption) === 'None'" style="display: inline">{{"newOrder.hechtProposal.response.none" | translate}}</div>
                <div class="info" *ngIf="isVitaDt(additionalOption)">
                    <img src="assets/img/icons/info.svg" [matTooltip]="'newOrder.hechtProposal.response.vitaDtHint' | translate" matTooltipPosition="above">
                </div>
            </div>
        </mat-radio-button>
    </mat-radio-group>
    <form [formGroup]="formResponse" style="width: 525px;">
        <div *ngIf="selectedAdditionalOption && getKey(selectedAdditionalOption) !== 'Prisma' && getKey(selectedAdditionalOption) !== 'None'" class="margin-top">
            <div class="select-box" *ngFor="let child of childrenAdditionalOption" style="display: inline-block;">
                <div *ngIf="!isNumber(child)" style="width: 100px;">
                    <mat-label [matTooltip]="getHintTranslationResponseParameters(child) | async" matTooltipPosition="above" class="label-option">{{getLabel(child) | async}}</mat-label>
                    <mat-select [value]="getDefaultValueSelect(child)" [formControlName]="getFormControlName(child)" class="form-control" style="width: 100px;">
                        <mat-option *ngFor="let currentValue of getChildrenAdditionalOptionValues(child)" [value]="currentValue" >
                            {{currentValue}}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="flex-grow-1 input-add-option" *ngIf="isNumber(child)">
                    <mat-label [matTooltip]="getHintTranslationResponseParameters(child) | async" matTooltipPosition="above">{{getLabel(child) | async}}</mat-label>
                    <input type="text" class="form-control" [value]="getDefaultValueNumber(child)" [formControlName]="getFormControlName(child)" (blur)="setValueWithFormat(getKey(child))">
                </div>
            </div>
        </div>
        <div *ngIf="selectedAdditionalOption && getKey(selectedAdditionalOption) === 'Prisma' && getKey(selectedAdditionalOption) !== 'None'" class="margin-top">
            <div class="select-box" style="display: inline-block;">
                <div style="width: 100px;">
                    <mat-label [matTooltip]="'common.hints.PrismType' | translate" matTooltipPosition="above" class="label-option">{{"common.features.PrismType" | translate}}</mat-label>
                    <mat-select [(value)]="selectedPrismType" formControlName="PrismType"  class="form-control" style="width: 100px;">
                        <mat-option *ngFor="let currentValue of childrenPrismType" [value]="currentValue">
                            {{currentValue}}
                        </mat-option>
                    </mat-select>
                </div>
            </div>
            <div *ngIf="selectedPrismType" class="select-box" style="display: inline-block;">
                <div class="flex-grow-1 input-add-option">
                    <mat-label [matTooltip]="'common.hints.Prism' | translate" matTooltipPosition="above">{{"common.features.Prism" | translate}}</mat-label>
                    <input type="text" class="form-control" [value]="getPrismDefaultValue()" [formControlName]="prismFormControl" (blur)="setValueWithFormat('Prism')">
                </div>
            </div>
        </div>
    </form>
    <div *ngIf="additionInfo">
        <h4 style="color: red">{{additionInfo}}</h4>
    </div>
</div>